import { render, staticRenderFns } from "./CommissionInsuredColumn.vue?vue&type=template&id=6d897e9a&scoped=true&"
import script from "./CommissionInsuredColumn.vue?vue&type=script&lang=js&"
export * from "./CommissionInsuredColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d897e9a",
  null
  
)

export default component.exports